export const NAVBAR = [
	/*{
		id: 1,
		name: 'How it works',
		to: '',
		target: '_blank',
	},*/
	/*{
		id: 0,
		name: 'Explainer Video',
		to: '',
		target: '_blank',
	},*/
	/*{
		id: 2,
		name: 'Audit Report',
		to: '',
		target: '_blank',
	},*/

	{
		id: 1,
		name: '',
		to: '',
		target: '_blank',
	},
];
